import axios from 'axios'
import router from '@/router'
import utils from './utils'
import { getStore, keys,clearStore } from '@/store';
import { getRequestLang } from '@/utils/lang';
import { ROUTE } from '@/router/paths';

// axios.defaults.baseURL = 'https://panda.edu.yuejike.com'//测试环境
axios.defaults.baseURL = 'https://edu.pandamandarincs.com'//正式环境
axios.interceptors.request.use(config => {
  // 每次请求后台的时候，如果有token，需要请求头携带token。
  // }
  const lang = getRequestLang()
  config.headers.Authorization = `Bearer ${getStore(keys.token)}`
  config.headers.lan = lang
  config.headers.lang = lang
  return config
}, err => Promise.reject(err))
axios.interceptors.response.use(res => {
  if (utils.GetQueryString('invite_code')) {
    if(utils.GetQueryString('salecard')){
      router.push({
        path: ROUTE.SALE_CARD,
        query: { invite_code: utils.GetQueryString('invite_code') }
      })
    }

  } else if (res.data.code === 10001) {
    router.push('/')
    clearStore()
  }
  return res
}, err => {
  // 根据当前的响应状态码是不是401去跳转登录页面

  // 状态码  err.response.status 就是
  if (err.response.status === 401) {
    router.push('/')
  }

  return Promise.reject(err)
})
export default axios



// WEBPACK FOOTER //
// ./src/utils/request.js